import { render, staticRenderFns } from "./kill_pts_input.vue?vue&type=template&id=06f2c1d0&scoped=true"
import script from "./kill_pts_input.vue?vue&type=script&lang=js"
export * from "./kill_pts_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f2c1d0",
  null
  
)

export default component.exports